// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Image__Wrapper_3SbM2","WithText":"Image__WithText_3p4zK","Text":"Image__Text_1hrdT"};